import { render } from "./ModalComponentHeader.vue?vue&type=template&id=0349d1aa&scoped=true"
const script = {}

import "./ModalComponentHeader.vue?vue&type=style&index=0&id=0349d1aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0349d1aa"]])

export default __exports__